var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcessCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.601 3.814l.763-.763-1.414-1.415-.763.763A6.95 6.95 0 009 1.08V0H7v1.08A6.942 6.942 0 003.814 2.4l-.764-.764L1.636 3.05l.763.763A6.95 6.95 0 001.08 7H0v2h1.08a6.942 6.942 0 001.32 3.186l-.764.764 1.414 1.414.763-.763a6.958 6.958 0 003.186 1.32V16h2v-1.08a6.942 6.942 0 003.186-1.32l.763.763 1.414-1.414-.763-.763A6.958 6.958 0 0014.919 9H16V7h-1.08a6.941 6.941 0 00-1.319-3.186zM8 11a3 3 0 110-6 3 3 0 010 6z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 8,
    cy: 8,
    r: 2
  })));
}
export default SvgProcessCircle;